export class InvalidPasswordResetCodeError extends Error {
  constructor(code: string) {
    super(`Invalid password reset code: ${code}`);
  }
}
